import { CreateMixin } from "@pdfking/reactivity/preact"

export const FieldMixin = CreateMixin({
  props: {
    disabled: false,
    field_key: "",
    path: "",
  },
})
